import { TInputParams } from 'entries/common/widgets/context';
import { FieldValues } from 'react-hook-form';
import { ParametersEnum } from '../../types';

export const getAreaState = ({
  inputParams,
  isEnabled,
}: {
  inputParams: TInputParams;
  isEnabled: boolean;
}) => {
  const withArea = inputParams.filter(
    param => ![ParametersEnum.length, ParametersEnum.width].includes(param)
  );
  return isEnabled ? [ParametersEnum.area, ...withArea] : inputParams;
};

export const checkIsSumWrong = (data: FieldValues) => {
  if (!data.length) {
    return undefined;
  }
  const length = Number(data.length);
  const width = Number(data.width);
  const height = Number(data.height);
  const doorsResult = Number(data.doors) * 1.4;
  const windowsResult = data.windows ? Number(data.windows) * 2.73 : 0;
  const sum = (length + width) * 2 * height - doorsResult - windowsResult;

  return sum <= 0;
};
